import { AgentData } from '@core/models/agent-data.model';
import { createAction, props } from '@ngrx/store';

export const agentDataEdit = createAction('[AgentData] Agent data changed', props<{ agentData: AgentData }>());
